import { Editor } from '@tiptap/react'
import { useMemo } from 'react'
import { Checkbox } from 'antd'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { useOutletContext } from 'react-router-dom'
import { Publication } from '../../utils/api-utils'
import { BUTTON_SIZE_TYPES, MODE_TYPES, DEFAULT_BACKGROUND_COLOR } from '../forms/Editor/extensions/Link/Link'
import FormItem from '../forms/utils/FormItem'
import TextInput from '../forms/utils/TextInput'
import FormModal from './FormModal'
import ColorPicker from '../forms/ColorPicker'

interface EditorLinkModalValues {
    href: string | null,
    trackConversion: boolean,
    text: string,
    mode: MODE_TYPES,
    backgroundColor: string | null,
    size: BUTTON_SIZE_TYPES | null
}
interface EditorLinkModalProps {
    open: boolean,
    editor: Editor,
    onOk: (values: EditorLinkModalValues) => void,
    onCancel: () => void
}

const EditorLinkInputs = () => {
    const form = useFormContext<EditorLinkModalValues>();
    const register = form.register;
    const publication = useOutletContext<Publication>()
    const mode = useWatch({name: 'mode'})

    return (
        <>
            <FormItem label='URL' top>
                {/* TODO: Refactor radio and checkbox inputs */}
                <Controller
                    name='href'
                    control={form.control}
                    render={({
                        field: { onChange, value }
                    }) => (
                        <>
                            <div>
                                <input
                                    type='radio'
                                    name='urlType'
                                    id='publicationUrl'
                                    className='mr-2'
                                    checked={value === null}
                                    onChange={() => onChange(null)}
                                />
                                <label htmlFor='publicationUrl'>Publication's landing page 
                                    <div className='text-ellipsis overflow-hidden whitespace-nowrap' title={`https://${publication.landingpage}`}>https://{publication.landingpage}</div>
                                </label>
                            </div>
                            <div className='mt-2'>
                                <input
                                    type='radio'
                                    name='urlType'
                                    id='customUrl'
                                    className='mr-2'
                                    checked={value !== null}
                                    onChange={() => onChange('https://')} />
                                <label htmlFor='customUrl'>Custom</label>

                                {value !== null && <TextInput className='mt-2' value={value} onChange={onChange} autoFocus />}
                            </div>
                        </>
                    )}
                />
            </FormItem>

            <FormItem>
              <Controller 
                name='trackConversion'
                control={form.control}
                render={({ field: { onChange, value } }) => (
                  <Checkbox checked={value} onChange={onChange}>Register clicks as page-conversions</Checkbox>
                )}
              />
            </FormItem>

            <FormItem label='Appear as'>
                <Controller
                    name='mode'
                    control={form.control}
                    render={({
                        field: { onChange, value }
                    }) => (
                        <>
                            <div>
                                <input
                                    type='radio'
                                    name='mode'
                                    id='linkMode'
                                    className='mr-2'
                                    checked={value === MODE_TYPES.LINK}
                                    onChange={() => {
                                        onChange(MODE_TYPES.LINK)
                                        form.setValue('backgroundColor', null)
                                        form.setValue('size', null)
                                    }}
                                />
                                <label htmlFor='linkMode'>Link</label>
                            </div>
                            <div className='mt-2'>
                                <input
                                    type='radio'
                                    name='mode'
                                    id='buttonMode'
                                    className='mr-2'
                                    checked={value === MODE_TYPES.BUTTON}
                                    onChange={() => {
                                        onChange(MODE_TYPES.BUTTON)
                                        form.setValue('backgroundColor', DEFAULT_BACKGROUND_COLOR)
                                        form.setValue('size', BUTTON_SIZE_TYPES.LARGE)
                                    }} />
                                <label htmlFor='buttonMode'>Button</label>
                            </div>
                      </>
                    )}
                />
                            {mode === MODE_TYPES.BUTTON && (
                              <ColorPicker
                                name="backgroundColor"
                                defaultValue={DEFAULT_BACKGROUND_COLOR}
                                className='mt-3'
                              />
                            )
                          }
                            {mode === MODE_TYPES.BUTTON && <select
                                id='country'
                                autoComplete='country-name'
                                className='mt-1 w-[258px] bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm'
                                {...register('size')}
                                defaultValue={BUTTON_SIZE_TYPES.LARGE}
                            >
                                <option value={BUTTON_SIZE_TYPES.LARGE}>Large</option>
                                <option value={BUTTON_SIZE_TYPES.EXTRA_LARGE}>Extra Large</option>
                            </select>}
            </FormItem>
        </>

    )
}
export default function EditorLinkModal({ editor, ...props }: EditorLinkModalProps) {
    const editMode = editor.isActive('link')

    const defaultValues = useMemo(() => {
        // const { nodeBefore, nodeAfter } = editor.state.selection.$anchor

        if (editMode) {
            return {
                ...editor.getAttributes('link'),
                // text: `${nodeBefore?.text || ''}${nodeAfter?.text || ''}`
            }
        } else {
            return {
                href: null,
                mode: MODE_TYPES.LINK,
                trackConversion: true,
                // // @ts-ignore
                // // text: editor.commands.getSelectedText()
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.open])

    return (
        <FormModal {...props}
            title={editMode ? 'Edit Link' : 'Add Link'}
            okText={editMode ? 'Edit Link' : 'Add Link'}
            defaultValues={defaultValues}
            skipDirtyValidation={!editMode}
        >
            <EditorLinkInputs />
        </FormModal>
    )
}
